<!--!&#45;&#45; Hero Start &ndash;&gt;-->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/OUTBOUND.jpg') center center; background-size: cover">
    <div class="bg-overlay"></div>
    <div class="container">

        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">All your holiday arrangements to
                        suite your budget.</h1>
                    <p class="para-desc text-white-50">We arrange inbound journeys to Sri Lanka from a vast number of
                        international locations. We always thrive to cater to the travel preferences of each client and
                        have excellent relationships with repeat clients.</p>
                </div>
            </div>
            <!--end row-->
        </div>
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->

<section class="section">
    <div class="container">
        <div class="row mb-5">
            <h4 align="center">Outbound packages</h4>
            <div class="mt-4 row">
                <div class="col-xl-4 col-lg-4 mb-3" *ngFor="let p of pack">
                    <div class="card img shadow-md" style="background-size: cover; background: url({{p.url}});border-radius: 10px">
                        <div class="bg-overlay" style="border-radius: 10px"></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <h4 style="color: white">{{p.packageName}}</h4>
<!--                                    <p class="text-muted">He lay on his armour-like back, and if he lifted his head.</p>-->
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-primary" style=" margin-top: 31px;" (click)="booking(p)">
                                        book now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</section>



